
import axios from "axios";
import { get, writable } from "svelte/store";
import LoadState from "../../Enums/LoadState";

const VideoSatStore = {
	meta: {
		initState: writable(LoadState.INIT),
		loadState: writable(LoadState.INIT),
		opacity: writable(1.0),
		visible: writable(false)
	},
	results: {
		footprints: writable([])
	},
	actions: {
		init: () => {
			if (get(VideoSatStore.meta.loadState) !== LoadState.INIT) {
				return;
			}

			VideoSatStore.meta.loadState.set(LoadState.LOADING);
			console.log("Loading VideoSatStore...");

			const files = ["/files/vids/footprint.kml"];
			const results = [];
			const promises = files.map((file) => {
				return VideoSatStore.actions._loadKmlProps(file);
			});
			Promise.all(promises)
				.then((responses) => {
					VideoSatStore.results.footprints.set(responses);
					VideoSatStore.meta.loadState.set(LoadState.LOADED);
					const min = GeoHelper.metersToDegrees(responses[0].MINX, responses[0].MINY);
					const max = GeoHelper.metersToDegrees(responses[0].MAXX, responses[0].MAXY);
				})
				.catch((error) => {
					console.error(error);
				});
		},
		_loadKmlProps: (file) => {
			return new Promise((resolve, reject) => {
				const fileUrl = window.location.origin + file;
				axios.get(fileUrl)
					.then(response => {
						return { success: (response.status === 200), data: response.data };
					})
					.then((response) => {
						if (!response.success) {
							console.warning("VideoSatStore.init", response);
							return;
						}

						const parser = new DOMParser();
						const doc = parser.parseFromString(response.data, "text/xml");
						const props = doc.getElementsByTagName("SimpleData");
						const obj = {};
						for (let i = 0; i < props.length; i++) {
							const prop = props.item(i);
							const name = prop.attributes.getNamedItem("name").value;
							const value = prop.innerHTML;
							obj[name] = value;
						}
						resolve(obj);
					})
					.catch(error => {
						console.error("VideoSatStore.init", error);
						reject(error);
					});
			});
		}
	}
};

export default VideoSatStore;
